type Store = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;
export function savedWarehouseAccount(storage: () => Store = () => sessionStorage) {
  try { return storage().getItem('warehouse_shop'); } catch { return null; }
}
/** A browser preference must never make a valid native session fail. */
export function rememberWarehouseAccount(id: string | null, storage: () => Store = () => sessionStorage) {
  try { if (id) storage().setItem('warehouse_shop', id); else storage().removeItem('warehouse_shop'); } catch { /* Storage may be unavailable in this browser. */ }
}
